module.exports = __webpack_public_path__ + "static/media/customerRelationship.b08d8d6e.svg";